"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "onChange"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/InputPassword/index.js";
var noop = function noop() {};
var defaultProps = {
  type: 'password',
  onChange: noop
};
function InputPassword(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value;
    onChange(value);
  }
  function showPasswordClick(e) {
    var input = e.target.previousElementSibling;
    var isText = input.type === 'text';
    input.type = isText ? 'password' : 'text';
    if (isText) {
      e.target.classList.add("bi-eye-slash");
      e.target.classList.remove("bi-eye");
    } else {
      e.target.classList.remove("bi-eye-slash");
      e.target.classList.add("bi-eye");
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    autoComplete: "new-password",
    className: (0, _classNames["default"])('form-control border-end-0 pe-0', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-link text-muted shadow-none bi bi-eye-slash",
    onClick: showPasswordClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 13
    }
  }));
}
InputPassword.defaultProps = defaultProps;
var _default = exports["default"] = InputPassword;